export interface IGroupLayerProps {
    /** 是否临时组 */
    isExtraGroup: boolean;

    isTextMaterial?: boolean;

    isVip?: boolean;

    /**图片翻译时不支持解组 */
    __isImageTrans?: boolean;

    /** 扩展信息 */
    extension?: IPuzzleLayer;
}

/** 组图层的扩展信息 */
export interface IGroupExtension {
    /** 组图层的内边距, 顺序为 top, right, bottom, left */
    padding?: number | number[];
    /** 组图层的角色 */
    role: GroupRoleType;
}

/** 组图层的角色 */
export enum GroupRoleType {
    /** 拼图 */
    PUZZLE = 'puzzle',
}

/** 拼图图层的扩展信息 */
export interface IPuzzleLayer extends IGroupExtension {
    // 拼图其他属性
    puzzleMode: string;

    enableSeamless: boolean;

    seamlessValue: number;

    enableEdge: boolean;

    edgeInnerWidth: number;

    edgeCornerRadius: number;

    containerLayers: {
        left: number;
        top: number;
        width: number;
        height: number;
        widthPercent: number;
        heightPercent: number;
        leftPercent: number;
        topPercent: number;
        stickerLayer: number;
        rotate: number;
    }[];

    backgroundLayer: {
        backgroundColor: string;
        backgroundGradient: {
            colors: { color: string; value: number }[];
            angle: number;
            type?: number;
            point?: { x: number; y: number };
        } | null;
    };

    frameScale: number;
}
